import { DataService } from '../../../../services/data_service';
import { IDs } from '../../../../helpers/IDs';
import { TriggerService } from '../../../../core/trigger/trigger_service';

export function importRow(row: any, data: any, dataService: DataService, triggerService: TriggerService, done: (values: any) => void) {
    data = data || {};
    row = row || {};
    const gewerk = +row.branchen_gewerke_tid_orig || null;
    const betriebliche_situation: string = row.betriebliche_situation_orig || row.betriebliche_situation || null;
    const jahr: number = +row.jahr || null;
    const unternehmen: string = row.unternehmen || null;
    const daten: any[] = JSON.parse(row.daten || '[]');
    const base: any[] = data[IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL] || [];
    const found_all: any[] = base.filter((old: any) => old.betrieb === unternehmen && old.jahr === jahr);
    const data_werte: any[] = [];

    daten.forEach((item: any) => {
        if (item.ignore || item.changed === false) {
            return;
        }
        const found: any = base.find((old: any) => old.betrieb === unternehmen && old.jahr === jahr && old.kuerzel === item.kuerzel);
        // console.log('FOUND OLD: ', found);
        const save_item = {
            tid: (found || {}).tid || 0,
            branchen_gewerke_tid: gewerk,
            kuerzel: item.kuerzel,
            jahr,
            betrieb: unternehmen,
            wert: item.wert,
            betriebliche_situation
        };
        if (found) {
            found.processed = true;
        }
        data_werte.push(save_item);
    });
    const data_del: any[] = found_all.filter((item: any) => !item.processed);
    // console.log('importRow', data_werte, data_del);

    if (!data_werte.length) {
        return;
    }
    dataService.saveDataList(IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL, data_werte, (sqlSuc: string, suc: boolean) => {
        if (suc) {
            const status_item = { tid: row.tid, status: 1 };
            dataService.saveData(IDs.ENT_KENNZAHLEN_IMPORT, status_item, undefined, false, (suc2: boolean, saveTid: number) => {
                if (triggerService) {
                    // Beim Massen-Import wird der absichtlich nicht übergeben, um zuviele Reloads zu vermeiden
                    triggerService.fire('reload', IDs.ENT_KENNZAHLEN_IMPORT);
                    if (!data_del.length) {
                        triggerService.fire('admin_reload', IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL);
                    }
                    alert(`Daten wurden importiert (${data_werte.length} Datensätze)!`);
                }
                done({ del: data_del.length, save: data_werte.length });
            }, IDs.MOD_ETOOL_ADMIN);
            if (!data_del.length) {
                return;
            }
            dataService.delDataList(IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL, data_del, () => {
                if (triggerService) {
                    // Beim Massen-Import wird der absichtlich nicht übergeben, um zuviele Reloads zu vermeiden
                    triggerService.fire('reload', IDs.ENT_KENNZAHLEN_IMPORT);
                    triggerService.fire('admin_reload', IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL);
                    alert(`Es wurden ${data_del.length} Datensätze entfernt!`);
                }
            }, IDs.MOD_ETOOL_ADMIN);
        } else {
            alert('Fehler beim Datenimport!');
            console.error(sqlSuc);
        }
    }, IDs.MOD_ETOOL_ADMIN);
}
